module.exports = __webpack_public_path__ + "static/media/icon-two-cards.a92e0b43.svg";